import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CommonService } from 'src/app/services/Common-function/common.service';
import { FormsService } from 'src/app/services/Forms/forms.service';
import { ShakeAnimationService } from 'src/app/services/shake-animation/shake-animation.service';
import { UserService } from 'src/app/services/user-service/user.service';

@Component({
  selector: 'ipm-update-email-popup',
  templateUrl: './update-email-popup.component.html',
  styleUrls: ['./update-email-popup.component.scss']
})
export class UpdateEmailPopupComponent implements OnInit {
  @Output() onSuccess: EventEmitter<string> = new EventEmitter();
  
  viewState: 'initiate' | 'verify' = 'initiate';
  emailForm: FormGroup;
  OTPInputData: any = {};
  errorMessage: string = '';
  newEmail: string = '';

  constructor(
    public commonService: CommonService,
    public formService: FormsService,
    public shakeAnimation: ShakeAnimationService,
    private userService: UserService
  ) { }

  ngOnInit(): void {
    this.emailForm = new FormGroup({
      'newEmail': this.formService.getFormControl('email'),
    });
  }

  initiateEmailUpdate(className: string) {
    if (this.emailForm.invalid) {
      this.emailForm.markAllAsTouched();
      return;
    }

    const payload = {
      newEmail: this.emailForm.value.newEmail
    };

    this.userService.initiateEmailUpdate(payload).subscribe(
      (res: any) => {
        this.newEmail = payload.newEmail;
        this.OTPInputData = {
          email: this.newEmail,
          callingFrom: 'emailUpdate',
          waitTimer: 60,
          channel: 'email',
          type: 'emailUpdate'
        };
        this.viewState = 'verify';
      },
      (error: any) => {
        this.shakeAnimation.addShakeAnimation(className);
        this.shakeAnimation.errorMessage = error?.error?.message || 'Failed to initiate update. Please try again.';
      }
    );
  }

  onVerifyOtp(event: any) {
    const otp = event?.code || event?.otp || event;
    if (!otp || otp.length < 6) return;
    
    this.userService.verifyEmailUpdate({ otp, code: otp }).subscribe(
      (res: any) => {
        this.commonService.showToastSuccess('Email updated successfully.');
        this.onSuccess.emit(this.newEmail);
        this.commonService.closingPopupWithSendData(this.newEmail);
      },
      (error: any) => {
        const msg = error?.error?.message || 'Invalid verification code.';
        if (msg.includes('Too many failed attempts')) {
          this.commonService.showToastErrorMessage(msg);
          this.viewState = 'initiate'; // Force back to start
          this.emailForm.reset();
        } else {
          this.errorMessage = '';
          setTimeout(() => {
            this.errorMessage = msg; // Pass error to otp-page
          }, 10);
        }
      }
    );
  }

  onResendOtp() {
    // Call initiate again with the same stored payload
    const payload = {
      newEmail: this.emailForm.value.newEmail
    };

    this.userService.initiateEmailUpdate(payload).subscribe(
      (res: any) => {
        this.commonService.showToastSuccess('Verification code sent to your new email address.');
      },
      (error: any) => {
        this.errorMessage = error?.error?.message || 'Failed to resend OTP.';
      }
    );
  }

  closeByDeviceType() {
    this.commonService.closingPopupWithSendData('');
  }
}
